import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';

/**
 * Service permettant de demander le rafraîchissement de la liste de trajets.
 */
@Injectable({
	providedIn: 'root'
})
export class RafraichissementTrajetsService {

	/**
	 * Subject représentant la demande de rafraîchissement.
	 */
	private readonly _declencheurRafraichissement = new Subject<void>();
	readonly declencheurRafraichissement = this._declencheurRafraichissement.asObservable();

	constructor() {
	}

	/**
	 * Demande de rafraîchir la liste des trajets.
	 */
	demanderRafraichissement(): void {
		this._declencheurRafraichissement.next();
	}
}
